export default __webpack_public_path__ + "static/media/calendar-green.41e27622.svg";